<template>
  <div class="lvdb-container" style="height: 100%;">
    <div class="qr-code-container" v-if="qrCode">
      <h4> {{ qrCodeText }}</h4>
      <img :src="qrCode" alt="" />
    </div>
    <div
      id="livedabStreamWidget"
      style="height: 100%; width: 100%;"
    />
  </div>
</template>

<script>
// JMT-1626 ECTRIMS 2021 | Integration of Livedab Virtual Photo Booth

export default {
  props: {
    streamOverlay: {
      type: Object,
      default() {
        return {}
      },
    },
    streamWidget: {
      type: Object,
      default() {
        return {}
      },
    },
    qrCodeText: {
      type: String,
      default: null,
    },
    qrCode: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.$loadScript('https://embed.livedab.com/livedab-stream-widget.js').then(() => {
      // eslint-disable-next-line max-len
      window.loadLiveDabOverlay(this.streamOverlay.apiUrl, this.streamOverlay.filterUrl, this.streamOverlay.streamLink, this.streamOverlay.authToken, this.streamOverlay.containerId)
      window.loadLiveDabPageWidget(this.streamWidget.apiUrl, this.streamWidget.streamLink, this.streamWidget.authToken)
    }).catch(() => {
      console.log('failed load livedab')
    })
  },
  beforeDestroy() {
    this.$unloadScript('https://embed.livedab.com/livedab-stream-widget.js')
      .then(() => {})
      .catch(() => {
        console.log('livedab script not find')
      })
  },
}
</script>

<style lang="scss">
.lvdb-container {
  display: flex;
  background-color: white;
}
.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 0 20px 20px;

  h4 {
    color: black;
  }
  img{
    max-width: 250px;
  }
}

</style>
